import { render } from "./EventSetup.vue?vue&type=template&id=6bccf47c"
import script from "./EventSetup.vue?vue&type=script&lang=js"
export * from "./EventSetup.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__